import { render } from "./ztn-drawer-item.vue?vue&type=template&id=3e5650a3&scoped=true&ts=true"
import script from "./ztn-drawer-item.vue?vue&type=script&lang=ts"
export * from "./ztn-drawer-item.vue?vue&type=script&lang=ts"

import "./ztn-drawer-item.vue?vue&type=style&index=0&id=3e5650a3&scoped=true&lang=css"

import exportComponent from "/src/node_modules/.pnpm/vue-loader@17.0.1_@vue+compiler-sfc@3.5.16_vue@3.5.16_typescript@4.8.4__webpack@5.84.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e5650a3"]])

export default __exports__